import React from 'react'
import { MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useMainState } from '@core/main-state'
import { normalizeLanguageCode, SUPPORTED_LANGUAGES } from '@core/utils/language'

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const isInternalAdmin = useMainState((state) => state.user?.internalAdmin)

  // Only show for internal admins (feature flag will be added in follow-up)
  if (!isInternalAdmin) {
    return null
  }

  const handleLanguageChange = (newLanguage: string) => {
    i18n.changeLanguage(newLanguage)
  }

  const currentLanguage = normalizeLanguageCode(i18n.language)

  return (
    <Select
      value={currentLanguage}
      onChange={(e) => handleLanguageChange(e.target.value)}
      size="small"
      sx={{
        minWidth: 120,
        '.MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      {SUPPORTED_LANGUAGES.map(({ code, name }) => (
        <MenuItem key={code} value={code}>
          {name}
        </MenuItem>
      ))}
    </Select>
  )
}
